var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 69,
    viewBox: "0 0 66 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.987 0.332862C47.5631 0.911962 56.8061 2.13371 62.3312 8.70734C67.5819 14.9545 65.6734 23.8572 65.6131 32.0119C65.5536 40.0672 66.7081 48.4409 61.9892 54.9752C56.5397 62.5213 48.2335 70.0367 38.987 68.882C30.003 67.7601 27.6423 56.1168 21.0997 49.869C14.2448 43.323 2.22146 41.3011 0.377121 32.0119C-1.59367 22.0859 4.42489 11.7512 12.2558 5.32601C19.5361 -0.647434 29.5848 -0.302022 38.987 0.332862Z",
    fill: "#F1EDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassBg);
export default __webpack_public_path__ + "static/media/ClassBg.25ffe8f69b084dcc9c128e2356a03378.svg";
export { ForwardRef as ReactComponent };